// store/vesselsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const lightHouseSlice = createSlice({
  name: "lightHouses",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    setLighthouses(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearLightHouses(state) {
      state.data = [];
    },
  },
});

export const { setLighthouses, setLoading, setError, clearLightHouses } =
  lightHouseSlice.actions;

export default lightHouseSlice.reducer;
